import React, { use, useEffect, useState, useTransition } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import "./styles/Formulario_subirReporte.css";
import "./styles/estandar/ButtonStyles.css";
import MensajeError from '../components/MensajeError';
import axios from 'axios';


import MenuBar from "../components/MenuBar";
import MenuHomeBox from "../components/MenuHomeBox";
import LogHomeBox from "../components/LogHomeBox";
import { validatePropertyDeps } from "ajv/dist/vocabularies/applicator/dependencies";
import Cookies from 'js-cookie';
import { MdFileUpload } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { eventWrapper } from "@testing-library/user-event/dist/utils";
import loadingIcon from '../assets/img/loadico.png';
import { IoMdWarning } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";

import { useConfig } from '../contexts/ConfigContext';

//RepPrNCA
const FormularioSubirReporte = () =>{
    const config = useConfig();
    const API_URL = `${config.API_URL}/api/registro/`;

     // Estado para almacenar el archivo seleccionado
    const [selectedFile, setSelectedFile] = useState(null); 
    const [fileName, setFileName] = useState(''); 
    // Bandera para mostrar el siguente campo
    const [showInpPages, setShowInpPages] = useState(false);
    
    const [nombrePagina, setNombrePagina] = useState('');
    //Arreglo de items de paginas Excel
    const [itemPaginas, setItemPaginas] = useState([]);

    //Mensajes de error:
    const [genericMensajeError, setGenericMensajeError] = useState('');
    const [showMensajeError, setShowMensajeError] = useState(false);


    //Bandera para mostrar boton de SUBIDA
    const [showBtnUp, setShowBtnUp] = useState(false);
    

    //Pantalla de carga
    const [mostrarCarga, setMostrarCarga] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [mensajeEstado, setMensajeEstado] = useState('Se ha subido correctamente');
    const [itemError, setItemError] = useState([]);
    const [hayErrores, setHayErrores] = useState(false);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [totalErrores, setTotalErrores] = useState(0);


     const navigate = useNavigate();
    /*Funcion para validar el tipo de session*/
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid !== "rid2"){
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }

    }

    useEffect(() =>{
        validarSesion();
    },[])


    const handleFileChange = async(event) =>{
        event.preventDefault();
        const file = event.target.files[0];
    
        if (file) {
        // 1. Guardar el objeto File en el estado
        setSelectedFile(file);
        setFileName(file.name); 

        // 2. Llamar a la función de subida usando el archivo guardado (o pasándolo directamente)
        // En este caso, lo pasamos directamente para mantener la inmediatez:
        //obtenerListaDeHojas(file); 
             axios.interceptors.request.use(
                (config) => {
                    const token = Cookies.get('usr');
                    if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                    }
                    return config;
                },
                (error) => {
                    console.error(error)
                });

                const formData = new FormData();
                // 'file' debe coincidir con el nombre del parámetro esperado en el backend (.NET)  
                formData.append('file', file); 

                try{
                    const response = await axios.post(API_URL + "obtenerHojasExcel", formData, {headers: {},Authorization: true});
                    console.log(response.data);
                    setItemPaginas(response.data);
                    setShowInpPages(true);

                }catch(error){
                    console.log(error);
                    setShowMensajeError(true);
                    setGenericMensajeError(error.message);
                }

        } else {
        // Si el usuario cancela la selección, limpiamos el estado
        setSelectedFile(null);
        setFileName('');
        }
    }

    const handleSubirReport = async() =>{
        try {
                setMostrarCarga(true);
                // 1. Crear el objeto FormData
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('nombre_hoja', nombrePagina);

                // 2. Definir la URL del endpoint
  

                // 3. Configurar los headers de la petición
            //Configuramos axios para que añada al header el respectivo token
                axios.interceptors.request.use(
                (config) => {
                    const token = Cookies.get('usr');
                    if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                    }
                    return config;
                },
                (error) => {
                    console.error(error)
                }
                );



                // 4. Enviar la petición POST con Axios
                const response = await axios.post(API_URL + "subir_reporte", formData, {Authorization: true});

                // 5. Manejar la respuesta exitosa
                if(response.status === 200){
                    setMostrarCarga(false);
                    setShowPreview(true);
                    const okReg =  response.data.okRegistros;
                    setTotalRegistros(okReg);
                    setMensajeEstado("Se ha subido el reporte exitosamente - [" + okReg +"] registros subidos");
                    setHayErrores(false);
                }else if(response.status === 201){
                    setMostrarCarga(false);
                    setShowPreview(true);
                    //setItemError(response.data.Listaerrores);
                    const itemError = response.data.listaerrores;
                    //console.log(itemError);
                    setItemError(itemError);
                    setMensajeEstado("Se han encontrado: "+response.data.numeroErrores+" errores, en el archivo proporcionado, se ha cancelado la carga del archivo");
                    setHayErrores(true);
                }else{

                    setMostrarCarga(false);
                    setShowMensajeError(true);
                    setGenericMensajeError("Ha ocurrido un error al subir el reporte");
                }
                return response.data;
            } catch (error) {
                setMostrarCarga(false);
                setShowMensajeError(true);
                setGenericMensajeError(error.message);
            }
    }

    const handlePrevisualizacion = (valor) =>{
        if(valor !== ''){
            setNombrePagina(valor);
            setShowBtnUp(true);
        }else{
            setShowBtnUp(false);
            setNombrePagina('');
        }
        
    }

    const handleCloseError = () => {
        setShowMensajeError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setGenericMensajeError(''); // Opcional: limpia el mensaje de error
        window.location.reload(); 

    };

    const handleRegresarRelacion = () =>{
        navigate('../Relacion');
         

    }

    

    return(
        <div className="FSR-mainHomeBox">
            <MenuBar pagina="Relacion" sesion={admin}/>
            <MensajeError mensaje={genericMensajeError} show={showMensajeError} onClose={handleCloseError}/>
            <div className="FSR-mainHomeBody">
                <h1 className="FSR-title">Subir reporte</h1>
                    <div className="FSR-mainContent">
                        <div className={!mostrarCarga && !showPreview ? "FSR-formContainer":"FSR-hide"}>
                            <button onClick={handleRegresarRelacion} className="FSR-Retu"><IoMdArrowRoundBack size="18px"/> Regresar</button>
                            <form onSubmit={(e)=>{e.preventDefault(); handleSubirReport()}}>
                                <div>
                                    <label id="FSR-fileLabel"> 1. Seleccione un archivo:</label>
                                    <label htmlFor="excel-file-upload" className="custom-upload-button">
                                        <PiMicrosoftExcelLogoFill size="20px"/>
                                        Seleccionar Archivo Excel
                                    </label>
                                    <input 
                                        id="excel-file-upload" // ID de enlace
                                        type="file" 
                                        onChange={handleFileChange} 
                                        className="hidden-input" // Clase para ocultarlo con CSS
                                        accept=".xlsx, .xls"
                                    />
                                </div>
                                {showInpPages &&
                                <div id="containerPaginas">
                                    <label id="FSR-fileLabel">2. Nombre del archivo:</label>
                                    <h5>{fileName}</h5>
                                    <label id="FSR-fileLabel">3. Seleccione una pagina:</label>
                                    <select className="inputF" value={nombrePagina} onChange={(e) =>{handlePrevisualizacion(e.target.value)}}>
                                        <option selected value={''}>---Nombre p&aacute;gina---</option>
                                        {itemPaginas.map((nombreHoja, index) => (
                                        <option key={index} value={nombreHoja}>{nombreHoja}</option>
                                        ))}
                                    </select>
                                </div>

                                }
                                {showBtnUp && <button type="submit" id="FTR-UpBton" className="buttonStandartGreen"><MdFileUpload size="20px"/>Cargar reporte</button>}
                            </form>
                        </div>
                        {mostrarCarga &&  
                        <div className="FSR-loadingBox">
                            <img className='imgLoadingLogin' src={loadingIcon}/>
                        </div>}
                        {showPreview &&
                            <div className="FSR-PreviewBox">
                                {hayErrores?<IoMdWarning size="50px" color="red"/>:<FaCheckCircle size="50px" color="green"/>}
                                <h1>{mensajeEstado}</h1>
                                <div className="FSR-LIST-ERRORS">
                                 {itemError?.map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                                </div>
                                <button className="buttonStandartGreen" onClick={(e)=>{e.preventDefault();handleRegresarRelacion()}}>Aceptar</button>
                            </div>
                        }
                      
                       
                  
    
                  
            </div>
                
          

            </div>
            
        </div>
    );
}

export default FormularioSubirReporte;